import styled from 'styled-components'
import { breakpoints } from 'src/utils/styles/global-styles'
import theme from 'src/utils/styles/theme'

export const BannerContainer = styled.div`
  background-color: ${(props) => props.promoBannerBkgdColor ?? '#D5B6EC'};
  padding: 24px 32px 16px;
  margin-bottom: 24px;
  text-align: center;
  border-radius: 8px;
  @media (max-width: ${breakpoints.s}px) {
    /* width: ${(props) => (props.cal ? '120%' : '100%')}; */
    position: relative;
    /* left: -6%; */
    margin-top: 16px;
    padding: 16px 12px 8px;
  }
`
export const TextContainer = styled.div`
  margin: auto;
  @media (max-width: ${breakpoints.s}px) {
    width: 100%;
  }
`
export const PromoHeader = styled.h3`
  color: ${theme.space};
  text-align: center;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: 'MatterBold';
  font-size: 14px;
  font-style: normal;
  line-height: 21px;
  margin: 0px;
`

export const DiscountText = styled.h3`
  margin: 0px;
  color: ${(props) => props.color ?? theme.white};
  text-align: center;
  font-family: 'MatterRegular';
  font-size: 26px;
  font-style: normal;
  line-height: 120%; /* 31.2px */
  letter-spacing: 0.52px;
  @media (max-width: ${breakpoints.s}px) {
    font-size: 22px;
  }
`
export const SubLabel = styled.h3`
  color: ${theme.space};
  font-family: 'P22MackinacProBold';
  text-align: center;
  font-size: 24px;
  margin: 0px;
  font-style: normal;
  line-height: 140%; /* 19.6px */
  letter-spacing: 0.28px;
`

export const StyledText = styled.span`
  color: ${(props) => props.styledTextColor ?? theme.white};
  font-family: 'MatterRegular';
  font-size: 14px;
  font-style: normal;
  line-height: 140%;
  letter-spacing: 0.28px;
`

export const DisclosureTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
  margin-top: 0px;
`
export const Disclosure = styled.p`
  margin: 0px;
  color: ${theme.space};
  text-align: center;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: 'MatterRegular';
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px; /* 140% */
`
